export default __webpack_public_path__ + "static/media/completed-early.07aa8034.svg";